import { useStoryContext } from "@/components/builder/stories/context";
import { GenrePill } from "@/components/builder/stories/genre-pill";

export function StoryGenreList() {
  const ctx = useStoryContext();

  return (
    <div className="flex flex-wrap justify-center gap-2">
      {ctx ? (
        ctx.data.genres?.map((genre) => (
          <GenrePill active key={genre} genre={genre} className="flex-grow-1 cursor-default sm:flex-grow-0" />
        ))
      ) : (
        <>
          <GenrePill active genre="couldn't load" className="flex-grow-1 cursor-default sm:flex-grow-0" />
          <GenrePill active genre="unpublished story?" className="flex-grow-1 cursor-default sm:flex-grow-0" />
        </>
      )}
    </div>
  );
}
